import NavigationLinkInteractionEvent, {
  type NavigationLinkPlacement
} from '~/events/NavigationLinkInteractionEvent';
import useRootData from '~/hooks/useRootData';
import useUser from '~/hooks/useUser';

export default function useNavigationLinkInteraction(
  placement: NavigationLinkPlacement
) {
  const { isBot } = useRootData();
  const user = useUser();

  return (destinationPath: string, position: number) =>
    new NavigationLinkInteractionEvent({
      destinationPath,
      gesture: 'click',
      guestId: user.guestId,
      isBot,
      placement,
      position
    }).send();
}
